import { CrawlerActive } from './CrawlerActive/CrawlerActive'
import { CrawlerFinished } from './CrawlerFinished'
import css from './CrawlerStatus.module.scss'
import { useFetchCrawlerJobs } from './hooks/useFetchCrawlerJobs'

export const CrawlerStatus = () => {
  const { startedCrawlerJob, finishedCrawlerJob, hasJobs } =
    useFetchCrawlerJobs()

  // Nothing at all without a job: the dashboard lays its rows out with a gap, and an
  // empty wrapper would still take one.
  if (!hasJobs) {
    return null
  }

  return (
    <div className={css.crawlerTotalStatus}>
      {!!finishedCrawlerJob && <CrawlerFinished jobId={finishedCrawlerJob} />}
      {!!startedCrawlerJob && <CrawlerActive jobId={startedCrawlerJob} />}
    </div>
  )
}
